import { render } from "./RelMinerals.vue?vue&type=template&id=5d409436&scoped=true"
import script from "./RelMinerals.vue?vue&type=script&lang=js"
export * from "./RelMinerals.vue?vue&type=script&lang=js"

import "./RelMinerals.vue?vue&type=style&index=0&id=5d409436&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d409436"]])

export default __exports__